import React, { useEffect, useState } from "react";
import '../../Elements/Element.css';
import "../../LeftSidebar/ElementsList.css";
import './ElementModal.css';
import { useSelector, useDispatch } from "react-redux";
import { addElementInUserActivity } from '../../../redux/slices/userActivity';
import imgPreview from '../../../assets/Images/image-preview.png';
import logoPreview from '../../../assets/Images/logo-preview-1.png';
import { showcreatorAnalyticsresponse, saveCreatorAnalyticsAsync } from "../../../redux/slices/CreatorAnalyticsReducer";

const ElementModal = ({ closeModal }) => {
    // const elementref = useRef(null);

    const dispatch = useDispatch();
    const { userActivities, selectedUserActivity, } = useSelector((state) => state.userActivity);
    const [textTab, settextTab] = useState(true);
    const [imageTab, setimageTab] = useState(true);
    const [buttonTab, setbuttonTab] = useState(true);
    const [fieldTab, setfieldTab] = useState(true);
    const save_canalytics_response = useSelector(showcreatorAnalyticsresponse);
    const [searchActive, setsearchActive] = useState(false);
    const [searchText, setsearchText] = useState("");
    const [isHovered, setIsHovered] = useState(false);
    const [idNum, setidNum] = useState(0);
    const [researcherTab, setresearcherTab] = useState(true);

    const [showElement, setShowElement] = useState(false);

    useEffect(() => {
        const activity = userActivities[selectedUserActivity];
        if (activity?.elements.length > 0) {
            var largestId = activity?.elements.reduce((max, item) => item.id > max ? item.id : max, activity?.elements[0].id);
            setidNum(largestId);
            // console.log("The largest id is: " + largestId);
        }

    }, [userActivities, selectedUserActivity]);

    const handleSearchBox = event => {
        // console.log(event);
        if (event.keyCode === 13) {
            // console.log("enter", searchText);
            setsearchActive(true);

            return;
        }
        setsearchText(event.target.value);
    };

    const handleClearSearch = () => {
        setsearchText("");
        document.getElementById("searchInput").value = "";
        setsearchActive(false);
    };

    const mockupResponse = [ // need default width height and desc to search
        {
            id: 1, text: 'Add a heading', fontWeight: 800, fontSize: 24, fontFamily: 'Poppins', textAlign: "center",
        },
        {
            id: 2, text: 'Add a subheading', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', textAlign: "center",
        },
    ];

    const mockupImage = [ // need default width height and desc to search
        {
            id: 1, height: 200, width: 200, url: imgPreview,
        },
        {
            id: 2, height: 100, width: 100, url: logoPreview,
        },
    ];

    const mockupButtonResponse = [ // need default width height and desc to search
        {
            id: 1, text: 'Submit', width: 200, height: "auto", fontWeight: 400, fontSize: 18, fontFamily: 'Poppins', backgroundColor: "#000000", border: "1px solid #000000", textAlign: "center", borderRadius: "8px"
        },
        {
            id: 2, text: 'Next', width: 200, height: "auto", fontWeight: 400, fontSize: 18, fontFamily: 'Poppins', backgroundColor: "#000000", border: "1px solid #000000", textAlign: "center", borderRadius: "8px"
        },
    ];

    const mockupFieldsResponse = [ // need default width height and desc to search
        {
            id: 1, text: 'Name', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Address', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Email', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Password', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Phone', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Number', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Date', fontWeight: 400, fontSize: 18, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },
        {
            id: 2, text: 'Browse Files', fontWeight: 400, fontSize: 16, fontFamily: 'Poppins', backgroundColor: "#ffffff", color: '#000000', border: "1px solid #F0EAEA", textAlign: "left", borderRadius: "0px"
        },

    ];

    const getTextWidth = (text, font) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        const metrics = context.measureText(text);
        // console.log(text, font, metrics.width);
        return metrics.width;
    }

    const addTextElementHandler = ({
        text, fontWeight, fontSize, fontFamily, textAlign
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'Text',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 250,
            height: "auto",
            width: "100%",
            elementAttributes: {
                color: '#000000', text,
                formattedText: [],
                // {
                //     "insert": "Add",
                //     "attributes": {
                //         "font_link": "https://dynamitech.in/",
                //         "font_color": "#2C80FFFF",
                //         "font_underline": true
                //     }
                // }
                fontFamily, fontWeight, fontSize, textAlign
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Text',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));

    }

    const addImageElementHandler = ({
        width, height, url
    }) => {
        const existingElements = userActivities[selectedUserActivity]?.elements || [];
        const element = {
            id: idNum + 1,
            elementType: 'Image',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 420 + existingElements.length * 20,
            posY: 220,
            height: height,
            width: width,
            elementAttributes: {
                url,
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Image',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addVideoElementHandler = () => {
        const existingElements = userActivities[selectedUserActivity]?.elements || [];
        const element = {
            id: idNum + 1,
            elementType: 'Video',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 360,
            posY: 150 + existingElements.length * 20,
            height: 300,
            width: 300,
            elementAttributes: {
                url: "",
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Video',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addAudioElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Audio',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 360,
            posY: 150,
            height: 55,
            width: 300,
            elementAttributes: {
                url: "",
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Audio',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addIframeElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Iframe',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 0,
            height: 575,
            width: 1024,
            elementAttributes: {
                url: "", border: "0px solid #000000"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Iframe',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addButtonElementHandler = ({
        width, height, text, fontWeight, fontSize, fontFamily, backgroundColor, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'Button',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 420,
            posY: 250,
            height: height,
            width: width,
            elementAttributes: {
                color: '#ffffff', text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "blue", border: "1px solid #000000"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Button',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addTextFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'TextField',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 0,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your text here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'TextField',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addTextAreaElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'TextArea',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 30,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your text here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'TextArea',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addEmailFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'Email',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 50,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your email here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Email',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addPasswordFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'Password',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 100,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your password here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Password',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addPhoneFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'Phone',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 150,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your phone number here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Phone',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addNumberFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'NumberField',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 170,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row", placeholder: "Type your number here."
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'NumberField',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }
    const addCheckboxElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Checkbox',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 300,
            posY: 150,
            height: "auto",
            width: 400,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                other: false,
                maxLength: null,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16,
                backgroundColor: "#ffffff",
                border: "1px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "25px",
                fieldPosition: "column",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'CheckboxGroup',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }
    const addCheckboxGroupElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'CheckboxGroup',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 300,
            posY: 150,
            height: "auto",
            width: 400,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                other: false,
                maxLength: null,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16,
                backgroundColor: "#ffffff",
                border: "1px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "25px",
                fieldPosition: "column",
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "Based on the objective, ask followup questions.",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'CheckboxGroup',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addCheckboxImageElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'CheckboxImage',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 10,
            posY: 100,
            height: "auto",
            width: 1000,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                optionsImage: ["", "", ""],
                maxLength: null,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "0px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "150px",
                imagePadding: "5px 15px 5px 5px",
                fieldPosition: "row",
                gap: "25px",
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "Based on the objective, ask followup questions.",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'CheckboxImage',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addRadioGroupElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'RadioGroup',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 300,
            posY: 150,
            height: "auto",
            width: 400,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                other: false,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16,
                backgroundColor: "#ffffff",
                border: "1px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                fieldPosition: "column",
                gap: "25px",
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "Based on the objective, ask followup questions.",

            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'RadioGroup',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }
    const addRadioImageElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'RadioImage',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 10,
            posY: 100,
            height: "auto",
            width: 1000,
            elementAttributes: {
                text: "Which of the following would you purchase?",
                options: ["Strut", "LuxeStep", "Velvet"],
                optionsImage: ["https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/17.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/18.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/19.png"],
                maxLength: null,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "0px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "150px",
                imagePadding: "5px 15px 5px 5px",
                fieldPosition: "row",
                gap: "25px",
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'RadioImage',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addRadioMultiImageElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'RadioMultiImage',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 50,
            posY: 10,
            height: "auto",
            width: '920px',
            elementAttributes: {
                text: "Which of the following would you purchase?",
                options: ["Strut", "LuxeStep", "Velvet", "Gait", "Solace", "Stride", "Evoque", "Arcus"],
                description: ["Step out with bold confidence in every stride.", "Luxury meets comfort in every graceful step.", "Smooth as velvet, crafted for elegance and ease.", "Perfectly balanced to match your every move.", "Find comfort and style in perfect harmony.", "Empower your steps with unmatched precision.", "Designed to evoke style and sophistication.", "Inspired by the beauty of arches in motion."],
                description2: ["Price: $85", "Price: $120", "Price: $100", "Price: $95", "Price: $110", "Price: $90", "Price: $130", "Price: $105"],
                optionsImage: ["https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/17.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/18.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/19.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/20.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/21.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/22.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/23.png", "https://duonutwebsitevideo.s3.us-east-2.amazonaws.com/icons_for_elements/24.png"],
                maxLength: null,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "0px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "130px",
                imagePadding: "5px 15px 5px 5px",
                fieldPosition: "row",
                gap: "20px",
                descriptionFontSize: 12,
                descriptionFontWeight: "400",
                descriptionColor: '#9B9B9B',
                description2FontSize: 16,
                description2FontWeight: "400",
                description2Color: '#000000',
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'RadioMultiImage',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }
    const addRatingElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Rating',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 180,
            posY: 250,
            height: "auto",
            width: 'auto',
            elementAttributes: {
                text: "Type your text here...",
                color: "#000000",
                ratingType: "star",
                maxLength: 5,
                fontFamily: "Poppins",
                fontWeight: "400",
                fontSize: 16,
                backgroundColor: "#4a90e2",
                textAlign: "center",
                borderRadius: '0px',
                size: 70,
                gap: "10px"
            },
            elementHoverAttributes: {
                backgroundColor: "#e4d16d", selectedBackgroundColor: "#7ed321"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Rating',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addNpsElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Nps',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 10,
            posY: 200,
            height: "auto",
            width: 1000,
            elementAttributes: {
                text: "Type your text here...",
                color: "white",
                maxLength: 6,
                positiveText: "",
                negativeText: "",
                fontFamily: "Poppins",
                fontWeight: "400",
                fontSize: 18,
                backgroundColor: "#4a90e2",
                textAlign: "center",
                borderRadius: '10px',
                margin: "5px 5px 5px 5px",
                padding: "0px 0px 0px 0px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                size: 70,
                gap: "50px",
                openEnded: true,
                openEndedObjective: "How are the customers rating?",
                openEndedFeedbackDesired: "What are customers rating the product?",
            },
            elementHoverAttributes: {
                backgroundColor: "#e4d16d", selectedBackgroundColor: "#7ed321"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Nps',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addMcqElementHandler = () => {
        const existingElements = userActivities[selectedUserActivity]?.elements || [];
        const element = {
            id: idNum + 1,
            elementType: 'Mcq',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 350,
            posY: 0 + existingElements.length * 40,
            height: "auto",
            width: 300,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                correctAnswer: 1,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16,
                backgroundColor: "#ffffff",
                border: "1px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "25px",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Mcq',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addMcqImageElementHandler = () => {
        const existingElements = userActivities[selectedUserActivity]?.elements || [];
        const element = {
            id: idNum + 1,
            elementType: 'McqImage',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0 + existingElements.length * 40,
            posY: 150,
            height: "auto",
            width: 'auto',
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                optionsImage: ["", "", ""],
                correctAnswer: 1,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "0px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "150px",
                imagePadding: "5px 10px 5px 5px",
                fieldPosition: "row",
                gap: "25px",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'McqImage',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addDropdownElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Dropdown',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 400,
            posY: 200,
            height: "auto",
            width: 500,
            elementAttributes: {
                text: "Select Option",
                options: ["Option 1", "Option 2", "Option 3"],
                fieldPosition: "column",
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff",
                border: "1px solid #000000",
                textAlign: "left", borderRadius: "5px",
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Dropdown',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addDropdownMultiselectElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'DropdownMultiselect',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 200,
            posY: 250,
            height: "auto",
            width: 500,
            elementAttributes: {
                text: "Select Option",
                options: ["Option 1", "Option 2", "Option 3"],
                fieldPosition: "column",
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#ffffff",
                border: "1px solid #000000",
                textAlign: "left", borderRadius: "5px",
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'DropdownMultiselect',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addDateFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'DateField',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 200,
            posY: 150,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'DateField',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addFileUploadFieldElementHandler = ({
        text, fontWeight, fontSize, fontFamily, backgroundColor, color, border, textAlign, borderRadius
    }) => {
        const element = {
            id: idNum + 1,
            elementType: 'FileUpload',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 300,
            posY: 100,
            height: "auto",
            width: 500,
            elementAttributes: {
                color, text, fontFamily, fontWeight, fontSize, backgroundColor, border, textAlign, borderRadius,
                fieldPosition: "row"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'FileUpload',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addReorderElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Reorder',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 0,
            posY: 350,
            height: "auto",
            width: 350,
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                color: '#ffffff', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#000000",
                border: "1px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "25px",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Reorder',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addReorderImageElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'ReorderImage',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 30,
            posY: 350,
            height: "auto",
            width: 'auto',
            elementAttributes: {
                text: "Type your text here...",
                options: ["Option 1", "Option 2", "Option 3"],
                optionsImage: ["", "", ""],
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "0px solid #E3DDDD",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "150px",
                imagePadding: "5px 10px 5px 5px",
                fieldPosition: "row",
                gap: "25px",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #E3DDDD"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'ReorderImage',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addFlipCardElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'FlipCard',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 150,
            posY: 0,
            height: "auto",
            width: "auto",
            elementAttributes: {
                text: "Type your text here...",
                f_text: "Fruit Name",
                b_text: "Apple",
                f_image: "",
                b_image: "",
                color: '#ffffff', fontFamily: "Poppins",
                fontWeight: 600, fontSize: 16, backgroundColor: "#000000",
                border: "1px solid #000000",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "15px",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #000000"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'FlipCard',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addMatrixElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'Matrix',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 350,
            posY: 0,
            height: "auto",
            width: "auto",
            elementAttributes: {
                text: "Type your text here...",
                questions: ["Question 1", "Question 2"],
                options: ["Option 1", "Option 2", "Option 3"],
                other: false,
                color: '#ffffff', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16,
                backgroundColor: "#000000",
                border: "1px solid #000000",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "10px 10px 10px 10px",
                labelFontSize: 16,
                labelFontWeight: "400",
                labelColor: '#000000',
                gap: "25px",
            },
            elementHoverAttributes: {
                color: '#ffffff', backgroundColor: "#3184c9", border: "1px solid #000000"

            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'Matrix',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));

    }

    const addQuestionAnswerElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'QuestionAnswer',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 100,
            posY: 100,
            height: "auto",
            width: 800,
            elementAttributes: {
                text: "Type your question?",
                height: "400px",
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 22,
                backgroundColor: "#ffffff",
                border: "1px solid #F0EAEA",
                textAlign: "left", borderRadius: "0px",
                placeholder: "Type your answer here.",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                openEnded: true,
                openEndedObjective: "",
                openEndedFeedbackDesired: "",
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'QuestionAnswer',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }
    const addGenericConjointElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'GenericConjoint',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 100,
            posY: 100,
            height: "auto",
            width: '820px',
            elementAttributes: {
                text: "Which of the following would you purchase?",
                options: [
                    { attribute: 'Engine capacity', levels: ['1.5L', '2L', '2.5L'] },
                    { attribute: 'Price', levels: ['$19000', '$25000', '$35000'] },
                    { attribute: 'Size', levels: ['Small', 'Medium', 'Large'] }
                ],
                showAttribute: true,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "1px solid #ccc",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "130px",
                imagePadding: "5px 15px 5px 5px",
                fieldPosition: "row",
                gap: "20px",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #000000"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'GenericConjoint',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    const addBestWorstConjointElementHandler = () => {
        const element = {
            id: idNum + 1,
            elementType: 'BestWorstConjoint',
            transparency: 1,
            zIndex: userActivities[selectedUserActivity]?.elements?.length + 1,
            order: userActivities[selectedUserActivity]?.elements?.length + 1,
            posX: 40,
            posY: 120,
            height: "auto",
            width: '950px',
            elementAttributes: {
                text: "Please review and select the options that are best and worst, in your opinion.",
                options: [
                    { attribute: 'Engine capacity', levels: ['1.5L', '2L', '2.5L'] },
                    { attribute: 'Price', levels: ['$19000', '$25000', '$35000'] },
                    { attribute: 'Size', levels: ['Small', 'Medium', 'Large'] }
                ],
                showAttribute: true,
                color: '#000000', fontFamily: "Poppins",
                fontWeight: 400, fontSize: 16, backgroundColor: "#FFFFFF",
                border: "1px solid #ccc",
                textAlign: "center", borderRadius: "5px",
                margin: "5px 5px 5px 5px",
                padding: "5px 5px 5px 5px",
                labelFontSize: 22,
                labelFontWeight: "400",
                labelColor: '#000000',
                imageWidth: "130px",
                imagePadding: "5px 15px 5px 5px",
                fieldPosition: "row",
                gap: "20px",
            },
            elementHoverAttributes: {
                color: '#000000', backgroundColor: "#FFFFFF", border: "0px solid #000000"
            },
        };
        dispatch(addElementInUserActivity({ activity: element, selectedActivityIdx: selectedUserActivity }));

        var save_creator_analytics = {
            element_type: 'BestWorstConjoint',
            watch_id: save_canalytics_response[0] ? save_canalytics_response[0].watch_id : "",
        }
        dispatch(saveCreatorAnalyticsAsync(save_creator_analytics));
    }

    return (

        <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', }}>
            <div style={{ width: '100%', background: '#cccccc57', height: '100%', textAlign: 'center', display: "flex", aligmItem: "flex-start", justifyContent: "space-between", gap: "15px" }}>
                {!showElement && (
                    <div style={{ margin: "15px", textAlign: 'center', display: "flex", alignItems: "center", width: "100%", justifyContent: "center" }}>
                        <p style={{ fontSize: "20px", color: "#5d5a5a", fontWeight: "bold" }}>
                            Search for any input field or layout option.<br />Click on any element to check the details and<br /> enter to insert the selected block/element.
                        </p>
                    </div>
                )}
                {/* <button className="GPT-submitBtn" style={{ marginTop: "10%" }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button> */}
                {showElement === "text" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Title</h2>
                                <p style={{ fontSize: "15px" }}>Use a bold and customizable heading to introduce your survey or define a specific section. This grabs attention and provides context for respondents.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextElementHandler(mockupResponse[0]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/heading.png" loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "primary" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Primary</h2>
                                <p style={{ fontSize: "15px" }}>Add detailed descriptions, instructions, or supporting information to guide users through your survey effectively.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextElementHandler(mockupResponse[1]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/sub-heading.png" loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "primary-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Primary Image</h2>
                                <p style={{ fontSize: "15px" }}> Insert a high-quality image to make your survey visually appealing or to illustrate your questions and content clearly.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addImageElementHandler(mockupImage[0]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/primary-image.png" style={{ width: "40%" }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "logo" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Logo</h2>
                                <p style={{ fontSize: "15px" }}>Include your brand logo to reinforce identity and ensure the survey feels professional and consistent with your branding.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addImageElementHandler(mockupImage[1]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/logo.png" style={{ width: "15%" }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "video" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Video</h2>
                                <p style={{ fontSize: "15px" }}>Embed a video to provide visual context, explain concepts, or enhance engagement with dynamic multimedia.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addVideoElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/video.png" style={{ width: "50%" }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "audio" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Audio</h2>
                                <p style={{ fontSize: "15px" }}>Add audio clips for voice instructions, background music, or sound-based questions to make your survey interactive and inclusive.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addAudioElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/audio.png" style={{ width: "60%" }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "iframe" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Iframe</h2>
                                <p style={{ fontSize: "15px" }}>Embed external web pages, tools, or forms directly into your survey to integrate additional resources or functionality seamlessly.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addIframeElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/iframe.svg" loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "primary-button" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Primary Button</h2>
                                <p style={{ fontSize: "15px" }}>A visually prominent and customizable button used for key actions like submitting responses or progressing through the survey. It ensures users can easily identify the main call to action.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addButtonElementHandler(mockupButtonResponse[0]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/submit.png" style={{ width: '30%' }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "next" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Next</h2>
                                <p style={{ fontSize: "15px" }}>A navigation button designed to let users move forward to the next question or section of the survey. It provides a smooth and intuitive user experience.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addButtonElementHandler(mockupButtonResponse[1]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/next.png" style={{ width: '30%' }} loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "text-field" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Text Field</h2>
                                <p style={{ fontSize: "15px" }}>A simple, single-line input field ideal for collecting short responses, such as names or short answers. It ensures quick and easy data entry.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[0]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div>
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/text-field.png" loading="lazy" />
                        </div>
                    </div>
                </>}
                {showElement === "text-area" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Text Area</h2>
                                <p style={{ fontSize: "15px" }}>A multi-line text box designed for longer and more detailed responses. This is perfect for comments, or additional feedback.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[1]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/text-area.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "email" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Email</h2>
                                <p style={{ fontSize: "15px" }}>A specific input field designed to collect email addresses, with built-in validation to ensure correct formatting. This element helps maintain accurate contact information.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[2]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/email.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "password" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Password</h2>
                                <p style={{ fontSize: "15px" }}>A secure input field for entering sensitive data, such as passwords oxr PINs. The text is hidden for privacy, with optional requirements like minimum length or complexity.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[3]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/password.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "phone" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Phone</h2>
                                <p style={{ fontSize: "15px" }}>An input field optimized for collecting phone numbers, it ensures user data is consistent and easy to process.

                                </p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[4]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/phone-number.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "number" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Number</h2>
                                <p style={{ fontSize: "15px" }}>A numeric-only input field that allows users to provide quantitative data like age, counts, or measurements. It includes built-in validation for numerical accuracy.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addTextFieldElementHandler(mockupFieldsResponse[5]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/number.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "check-box" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Checkbox</h2>
                                <p style={{ fontSize: "15px" }}>A set of checkboxes that lets users select multiple options from a list. Ideal for questions with more than one correct or acceptable answer.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addCheckboxElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/check-box.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "check-group" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>
                                    {/* Checkbox Group */}
                                    Multi choice multi select
                                    </h2>
                                <p style={{ fontSize: "15px" }}>A set of checkboxes along with open ended follow up questions. Ideal for questions with more than one acceptable answer.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addCheckboxGroupElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/check-box.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "check-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>
                                    {/* Checkbox Image */}
                                    Multi choice multi select Image
                                    </h2>
                                <p style={{ fontSize: "15px" }}>A visually engaging option where users select multiple images instead of text-based choices. This is perfect for surveys requiring visual engagement.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addCheckboxImageElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/check-image.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "radio-group" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>
                                    {/* Radio Group */}
                                    Multi choice single select
                                </h2>
                                <p style={{ fontSize: "15px" }}>A group of circular buttons that allow users to select a single option from a predefined list. This ensures clarity and prevents multiple selections for single-choice questions.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addRadioGroupElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/radio-text.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "radio-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>
                                    {/* Radio Image */}
                                    Multi choice single select Image
                                    </h2>
                                <p style={{ fontSize: "15px" }}>A selection element where users can choose one image from a visually appealing set of options. It supports open-ended follow-up questions, allowing users to elaborate on their choice or provide additional input.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addRadioImageElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/radio-image.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "radio-multi-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>
                                    {/* Radio Multi Image */}
                                    Multi choice single select with Multi Image
                                </h2>
                                <p style={{ fontSize: "15px" }}>A variation of the radio image element that lets users select multiple images from a predefined set. Open-ended follow-up questions can be included, encouraging users to explain or justify their selections.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addRadioMultiImageElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/radio-multi-image.png" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "matrix" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Matrix</h2>
                                <p style={{ fontSize: "15px" }}>A grid-style layout where users can respond to related questions across rows and columns. This is useful for capturing detailed feedback efficiently in a structured format.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addMatrixElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/matrix.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "rating" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Rating</h2>
                                <p style={{ fontSize: "15px" }}>A visual scale, often using stars or numbers, to let users rate their satisfaction, preferences, or experiences. It provides an easy-to-interpret measure of sentiment.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addRatingElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/rating.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "nps" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>NPS (Net Promoter Score)</h2>
                                <p style={{ fontSize: "15px" }}>A specialized rating element ranging from 0 to 10 to assess user loyalty or likelihood of recommending a product or service. It’s a widely used metric for gauging customer sentiment.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addNpsElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/nps.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "mcq" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>MCQ (Multiple Choice Question)</h2>
                                <p style={{ fontSize: "15px" }}>A question type with a list of predefined options where users can select one or more responses. It’s versatile and fits most question types in surveys.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addMcqElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/mcq.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "mcq-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>MCQ Image</h2>
                                <p style={{ fontSize: "15px" }}>A variation of multiple-choice questions where users select image-based options instead of text. Perfect for visual-based questions or preferences.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addMcqImageElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/mcq-image.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "dropdown" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Dropdown</h2>
                                <p style={{ fontSize: "15px" }}>A compact menu that expands to reveal a list of options, allowing users to select one. This is ideal for saving space and organizing lengthy option lists.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addDropdownElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/dropdown.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "date" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Date</h2>
                                <p style={{ fontSize: "15px" }}>A calendar-based input field that lets users select a specific date. It includes validation to ensure correct formatting and prevents errors in date selection.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addDateFieldElementHandler(mockupFieldsResponse[6]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/date.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "file-upload" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>File Upload</h2>
                                <p style={{ fontSize: "15px" }}> A feature allowing users to upload files, such as images, documents, or videos, as part of their response. This is useful for collecting supplementary information.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addFileUploadFieldElementHandler(mockupFieldsResponse[7]); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/upload.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "reorder" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Reorder</h2>
                                <p style={{ fontSize: "15px" }}>A drag-and-drop element where users can rearrange a list of items in order of preference or priority. It’s great for ranking-based questions.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addReorderElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/reorder.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "reorder-image" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>ReorderImage</h2>
                                <p style={{ fontSize: "15px" }}> Similar to reorder, but specifically for images. Users can drag and arrange images based on their preferences, enhancing interactivity.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addReorderImageElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/reorder-image.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "flip-card" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Flip Card</h2>
                                <p style={{ fontSize: "15px" }}>An interactive element where users can flip cards to reveal more details or make a choice. This adds a dynamic and engaging element to the survey.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addFlipCardElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/flip.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "question-answer" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Question Answer</h2>
                                <p style={{ fontSize: "15px" }}>A versatile element that combines predefined questions with open-ended follow-up options. This allows users to provide detailed responses or additional context beyond the initial selection.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addQuestionAnswerElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/question.svg" loading="lazy" />
                        </div>
                    </div >
                </>}
                {showElement === "generic-conjoint" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Generic Conjoint</h2>
                                <p style={{ fontSize: "15px" }}>A flexible component designed to support various use cases. It provides supplemental details or context to enhance user understanding and engagement. The conjoint text is versatile, making it ideal for secondary information, instructions, or descriptive content.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addGenericConjointElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/conjoint.png" loading="lazy" style={{ width: "85%" }} />
                        </div>
                    </div >
                </>}
                {showElement === "best-worst-conjoint" && <>
                    <div>
                        <div className="element-description">
                            <div style={{ margin: "15px", textAlign: 'left', width: '70%' }}>
                                <h2 style={{ marginBottom: "20px" }}>Best-Worst Conjoint</h2>
                                <p style={{ fontSize: "15px" }}>A flexible component designed to support various best-worst cases scenarios. It provides supplemental details or context to enhance user understanding and engagement. The conjoint text is versatile, making it ideal for secondary information, instructions, or descriptive content.</p>
                            </div>
                            <button className="element-insert-btn" onClick={() => { addBestWorstConjointElementHandler(); closeModal() }}>Insert <i class="fa fa-plus" aria-hidden="true"></i></button>
                        </div >
                        <div className="element-example">
                            <p className="element-example-p">Example</p>
                            <img className="element-example-img" src="../../../assets/elements/best-worst-conjoint.png" loading="lazy" style={{ width: "85%" }} />
                        </div>
                    </div >
                </>}
            </div>

            <div className="ElementMainContainer" style={{ overflow: isHovered ? "hidden auto" : "hidden" }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>

                <div className="sidebar_extension__searchbar">
                    <input id="searchInput" type="text" placeholder="Search" onKeyUp={e => handleSearchBox(e)} />
                    <img src="/assets/icons/search-icon.svg" className="search-icon" />
                    {searchActive && <img src="/assets/icons/close.svg" className="search-close-icon" onClick={() => handleClearSearch()} />}
                </div>

                <div className="ElementTextHeading" onClick={() => settextTab(!textTab)} >Text
                    <svg style={{ transform: textTab ? "rotate(180deg)" : "none", padding: "2px 4px" }} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26342 2.97603L2.24581 0.958417C1.6984 0.410996 0.81085 0.410997 0.263428 0.958418L4.26342 4.95841L8.26343 0.958418C7.71597 0.410997 6.82845 0.410997 6.28103 0.958418L4.26342 2.97603Z" fill="currentColor"></path>
                    </svg>
                </div>
                {textTab && <>
                    {((searchActive && "text".includes(searchText)) || !searchActive) && <div className="ElementTextContainer " onClick={() => { setShowElement('text'); }}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M38.6667 18H29.7778V21.3333H38.6667C39.1382 21.3333 39.5903 21.5089 39.9237 21.8215C40.2571 22.134 40.4444 22.558 40.4444 23V26.3333H33.3333C31.9193 26.3347 30.5635 26.8619 29.5637 27.7993C28.5638 28.7367 28.0014 30.0077 28 31.3333V33C28.0014 34.3257 28.5638 35.5967 29.5637 36.5341C30.5635 37.4715 31.9193 37.9987 33.3333 38H44V23C43.9986 21.6743 43.4362 20.4033 42.4363 19.4659C41.4365 18.5285 40.0807 18.0013 38.6667 18ZM33.3333 34.6667C32.8618 34.6667 32.4097 34.4911 32.0763 34.1785C31.7429 33.866 31.5556 33.442 31.5556 33V31.3333C31.5556 30.8913 31.7429 30.4674 32.0763 30.1548C32.4097 29.8423 32.8618 29.6667 33.3333 29.6667H40.4444V34.6667H33.3333Z" fill="#414859"></path>
                                <path d="M24.5714 38H28L17.7143 10H14.2857L4 38H7.42857L10.3326 29.7647H21.6691L24.5714 38ZM11.4931 26.4706L15.7737 14.3301H16.2297L20.5086 26.4706H11.4931Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText" style={{ dislpay: "flex" }}>
                            Title
                        </div>
                    </div>}

                    {((searchActive && "text".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => { setShowElement('primary'); }}
                        style={{
                            // borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M38.6667 18H29.7778V21.3333H38.6667C39.1382 21.3333 39.5903 21.5089 39.9237 21.8215C40.2571 22.134 40.4444 22.558 40.4444 23V26.3333H33.3333C31.9193 26.3347 30.5635 26.8619 29.5637 27.7993C28.5638 28.7367 28.0014 30.0077 28 31.3333V33C28.0014 34.3257 28.5638 35.5967 29.5637 36.5341C30.5635 37.4715 31.9193 37.9987 33.3333 38H44V23C43.9986 21.6743 43.4362 20.4033 42.4363 19.4659C41.4365 18.5285 40.0807 18.0013 38.6667 18ZM33.3333 34.6667C32.8618 34.6667 32.4097 34.4911 32.0763 34.1785C31.7429 33.866 31.5556 33.442 31.5556 33V31.3333C31.5556 30.8913 31.7429 30.4674 32.0763 30.1548C32.4097 29.8423 32.8618 29.6667 33.3333 29.6667H40.4444V34.6667H33.3333Z" fill="#414859"></path>
                                <path d="M24.5714 38H28L17.7143 10H14.2857L4 38H7.42857L10.3326 29.7647H21.6691L24.5714 38ZM11.4931 26.4706L15.7737 14.3301H16.2297L20.5086 26.4706H11.4931Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Primary
                        </div>
                    </div>}
                </>}
                <div className="ElementDividerLine"></div>

                <div className="ElementTextHeading" onClick={() => setimageTab(!imageTab)}>Image & Video
                    <svg style={{ transform: imageTab ? "rotate(180deg)" : "none", padding: "2px 4px" }} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26342 2.97603L2.24581 0.958417C1.6984 0.410996 0.81085 0.410997 0.263428 0.958418L4.26342 4.95841L8.26343 0.958418C7.71597 0.410997 6.82845 0.410997 6.28103 0.958418L4.26342 2.97603Z" fill="currentColor"></path>
                    </svg>
                </div>
                {imageTab && <>
                    {((searchActive && "image".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => { setShowElement('primary-image'); }}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 41C5.5 41.8284 6.17157 42.5 7 42.5H27.0663H41C41.8284 42.5 42.5 41.8284 42.5 41V33.7783C42.3846 33.7129 42.2761 33.631 42.1779 33.5326L37.2999 28.6465L31.6358 35.3988C31.1034 36.0335 30.1573 36.1164 29.5226 35.584C29.431 35.5072 29.3509 35.4217 29.2825 35.3299C29.186 35.2696 29.0949 35.1974 29.0113 35.1131L17.4911 23.504L5.5 35.495V41ZM30.3775 32.2308L36.0545 25.4631C36.3249 25.1407 36.7184 24.9467 37.1388 24.9285C37.5592 24.9103 37.9679 25.0695 38.2653 25.3673L42.5 29.6091V26.4838V6.99997C42.5 6.17154 41.8284 5.49997 41 5.49997H7C6.17157 5.49997 5.5 6.17154 5.5 6.99997V31.2524L16.4345 20.3179C16.7165 20.0359 17.0992 19.8778 17.498 19.8786C17.8969 19.8793 18.279 20.0389 18.5599 20.322L30.3775 32.2308ZM2.5 34.8737V41C2.5 43.4853 4.51472 45.5 7 45.5H27.0663H41C43.4853 45.5 45.5 43.4852 45.5 41V26.4838V6.99997C45.5 4.51469 43.4853 2.49997 41 2.49997H7C4.51472 2.49997 2.5 4.51469 2.5 6.99997V34.8737ZM35.3916 15.8203C35.3916 17.9964 33.6348 19.7605 31.4676 19.7605C29.3005 19.7605 27.5437 17.9964 27.5437 15.8203C27.5437 13.6443 29.3005 11.8802 31.4676 11.8802C33.6348 11.8802 35.3916 13.6443 35.3916 15.8203Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Primary
                        </div>
                    </div>}
                    {((searchActive && "image".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement('logo')}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 41C5.5 41.8284 6.17157 42.5 7 42.5H27.0663H41C41.8284 42.5 42.5 41.8284 42.5 41V33.7783C42.3846 33.7129 42.2761 33.631 42.1779 33.5326L37.2999 28.6465L31.6358 35.3988C31.1034 36.0335 30.1573 36.1164 29.5226 35.584C29.431 35.5072 29.3509 35.4217 29.2825 35.3299C29.186 35.2696 29.0949 35.1974 29.0113 35.1131L17.4911 23.504L5.5 35.495V41ZM30.3775 32.2308L36.0545 25.4631C36.3249 25.1407 36.7184 24.9467 37.1388 24.9285C37.5592 24.9103 37.9679 25.0695 38.2653 25.3673L42.5 29.6091V26.4838V6.99997C42.5 6.17154 41.8284 5.49997 41 5.49997H7C6.17157 5.49997 5.5 6.17154 5.5 6.99997V31.2524L16.4345 20.3179C16.7165 20.0359 17.0992 19.8778 17.498 19.8786C17.8969 19.8793 18.279 20.0389 18.5599 20.322L30.3775 32.2308ZM2.5 34.8737V41C2.5 43.4853 4.51472 45.5 7 45.5H27.0663H41C43.4853 45.5 45.5 43.4852 45.5 41V26.4838V6.99997C45.5 4.51469 43.4853 2.49997 41 2.49997H7C4.51472 2.49997 2.5 4.51469 2.5 6.99997V34.8737ZM35.3916 15.8203C35.3916 17.9964 33.6348 19.7605 31.4676 19.7605C29.3005 19.7605 27.5437 17.9964 27.5437 15.8203C27.5437 13.6443 29.3005 11.8802 31.4676 11.8802C33.6348 11.8802 35.3916 13.6443 35.3916 15.8203Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Logo
                        </div>
                    </div>}
                    {((searchActive && "video".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("video")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 6.99997C2.5 4.51469 4.51472 2.49997 7 2.49997H41C43.4853 2.49997 45.5 4.51469 45.5 6.99997V41C45.5 43.4853 43.4853 45.5 41 45.5H7C4.51472 45.5 2.5 43.4853 2.5 41V6.99997ZM7 5.49997C6.17157 5.49997 5.5 6.17154 5.5 6.99997V41C5.5 41.8284 6.17157 42.5 7 42.5H41C41.8284 42.5 42.5 41.8284 42.5 41V6.99997C42.5 6.17154 41.8284 5.49997 41 5.49997H7Z" fill="#414859"></path><path d="M30.25 24.433L21.25 29.6292C20.9167 29.8216 20.5 29.5811 20.5 29.1962L20.5 18.8038C20.5 18.4189 20.9167 18.1784 21.25 18.3708L30.25 23.567C30.5833 23.7594 30.5833 24.2406 30.25 24.433Z" fill="#414859" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><line x1="6.5" y1="37.5" x2="8.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="37.5" x2="21.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="37.5" x2="34.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="37.5" x2="41.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="6.5" y1="10.5" x2="8.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="10.5" x2="21.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="10.5" x2="34.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="10.5" x2="41.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Video
                        </div>
                    </div>}

                    {((searchActive && "audio".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("audio")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 6.99997C2.5 4.51469 4.51472 2.49997 7 2.49997H41C43.4853 2.49997 45.5 4.51469 45.5 6.99997V41C45.5 43.4853 43.4853 45.5 41 45.5H7C4.51472 45.5 2.5 43.4853 2.5 41V6.99997ZM7 5.49997C6.17157 5.49997 5.5 6.17154 5.5 6.99997V41C5.5 41.8284 6.17157 42.5 7 42.5H41C41.8284 42.5 42.5 41.8284 42.5 41V6.99997C42.5 6.17154 41.8284 5.49997 41 5.49997H7Z" fill="#414859"></path><path d="M30.25 24.433L21.25 29.6292C20.9167 29.8216 20.5 29.5811 20.5 29.1962L20.5 18.8038C20.5 18.4189 20.9167 18.1784 21.25 18.3708L30.25 23.567C30.5833 23.7594 30.5833 24.2406 30.25 24.433Z" fill="#414859" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><line x1="6.5" y1="37.5" x2="8.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="37.5" x2="21.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="37.5" x2="34.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="37.5" x2="41.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="6.5" y1="10.5" x2="8.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="10.5" x2="21.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="10.5" x2="34.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="10.5" x2="41.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Audio
                        </div>
                    </div>}

                    {((searchActive && "iframe".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("iframe")}
                        style={{
                            // borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            {/* <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 6.99997C2.5 4.51469 4.51472 2.49997 7 2.49997H41C43.4853 2.49997 45.5 4.51469 45.5 6.99997V41C45.5 43.4853 43.4853 45.5 41 45.5H7C4.51472 45.5 2.5 43.4853 2.5 41V6.99997ZM7 5.49997C6.17157 5.49997 5.5 6.17154 5.5 6.99997V41C5.5 41.8284 6.17157 42.5 7 42.5H41C41.8284 42.5 42.5 41.8284 42.5 41V6.99997C42.5 6.17154 41.8284 5.49997 41 5.49997H7Z" fill="#414859"></path><path d="M30.25 24.433L21.25 29.6292C20.9167 29.8216 20.5 29.5811 20.5 29.1962L20.5 18.8038C20.5 18.4189 20.9167 18.1784 21.25 18.3708L30.25 23.567C30.5833 23.7594 30.5833 24.2406 30.25 24.433Z" fill="#414859" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><line x1="6.5" y1="37.5" x2="8.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="37.5" x2="21.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="37.5" x2="34.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="37.5" x2="41.5" y2="37.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="6.5" y1="10.5" x2="8.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="13.5" y1="10.5" x2="21.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="26.5" y1="10.5" x2="34.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line><line x1="39.5" y1="10.5" x2="41.5" y2="10.5" stroke="#414859" stroke-width="3" stroke-linecap="square"></line>
                        </svg> */}
                            <i className="fa fa-code" aria-hidden="true"></i>
                        </div>
                        <div className="ElementText">
                            Iframe
                        </div>
                    </div>}

                </>}

                <div className="ElementDividerLine"></div>

                <div className="ElementTextHeading" onClick={() => setbuttonTab(!buttonTab)}>Button
                    <svg style={{ transform: buttonTab ? "rotate(180deg)" : "none", padding: "2px 4px" }} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26342 2.97603L2.24581 0.958417C1.6984 0.410996 0.81085 0.410997 0.263428 0.958418L4.26342 4.95841L8.26343 0.958418C7.71597 0.410997 6.82845 0.410997 6.28103 0.958418L4.26342 2.97603Z" fill="currentColor"></path>
                    </svg>
                </div>
                {buttonTab && <>
                    {((searchActive && "button".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("primary-button")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M37.7698 33.1133C38.6385 32.5877 39.2192 31.634 39.2192 30.5446V20.0131C39.2192 18.3562 37.8761 17.0131 36.2192 17.0131H7C6.39196 17.0131 5.82617 17.194 5.3535 17.5049L4.03638 16.7009L7.5975 14.3268C8.38886 13.9311 9.04931 13.6697 9.96792 13.6697H40.439C42.4057 13.6697 44.0001 15.2641 44.0001 17.2309V29.0142C44.0001 30.0704 43.5402 31.0193 42.8098 31.6714L42.8131 31.7476L39.2193 33.9039L37.7698 33.1133Z" fill="#414859"></path>
                                <rect x="4" y="17.0131" width="35.2192" height="16.5315" rx="3" stroke="#414859" stroke-width="3" stroke-linecap="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Primary
                        </div>
                    </div>}
                    {((searchActive && "button".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement('next')}
                        style={{
                            // borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M37.7698 33.1133C38.6385 32.5877 39.2192 31.634 39.2192 30.5446V20.0131C39.2192 18.3562 37.8761 17.0131 36.2192 17.0131H7C6.39196 17.0131 5.82617 17.194 5.3535 17.5049L4.03638 16.7009L7.5975 14.3268C8.38886 13.9311 9.04931 13.6697 9.96792 13.6697H40.439C42.4057 13.6697 44.0001 15.2641 44.0001 17.2309V29.0142C44.0001 30.0704 43.5402 31.0193 42.8098 31.6714L42.8131 31.7476L39.2193 33.9039L37.7698 33.1133Z" fill="#414859"></path>
                                <rect x="4" y="17.0131" width="35.2192" height="16.5315" rx="3" stroke="#414859" stroke-width="3" stroke-linecap="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Next
                        </div>
                    </div>}
                </>}

                <div className="ElementDividerLine"></div>

                <div className="ElementTextHeading" onClick={() => setfieldTab(!fieldTab)}>Fields
                    <svg style={{ transform: fieldTab ? "rotate(180deg)" : "none", padding: "2px 4px" }} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26342 2.97603L2.24581 0.958417C1.6984 0.410996 0.81085 0.410997 0.263428 0.958418L4.26342 4.95841L8.26343 0.958418C7.71597 0.410997 6.82845 0.410997 6.28103 0.958418L4.26342 2.97603Z" fill="currentColor"></path>
                    </svg>
                </div>
                {fieldTab && <>
                    {((searchActive && "text field".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("text-field")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M27.6363 19.4546H21.5756V21.7273H27.6363C27.9577 21.7273 28.266 21.847 28.4934 22.0601C28.7207 22.2732 28.8484 22.5623 28.8484 22.8637V25.1364H23.9999C23.0358 25.1373 22.1114 25.4967 21.4297 26.1359C20.7479 26.775 20.3645 27.6416 20.3635 28.5455V29.6818C20.3645 30.5857 20.7479 31.4523 21.4297 32.0914C22.1114 32.7306 23.0358 33.09 23.9999 33.0909H31.2726V22.8637C31.2717 21.9598 30.8882 21.0932 30.2065 20.4541C29.5247 19.8149 28.6004 19.4555 27.6363 19.4546ZM23.9999 30.8182C23.6784 30.8182 23.3701 30.6985 23.1428 30.4854C22.9155 30.2723 22.7878 29.9832 22.7878 29.6818V28.5455C22.7878 28.2441 22.9155 27.955 23.1428 27.7419C23.3701 27.5288 23.6784 27.4091 23.9999 27.4091H28.8484V30.8182H23.9999Z" fill="#414859"></path><path d="M18.026 33.0909H20.3636L13.3506 14H11.013L4 33.0909H6.33766L8.31766 27.4759H16.0471L18.026 33.0909ZM9.10896 25.2299L12.0275 16.9524H12.3384L15.2558 25.2299H9.10896Z" fill="#414859"></path><path d="M36.7046 30.6818C35.8762 30.6818 35.2046 31.3534 35.2046 32.1818C35.2046 33.0102 35.8762 33.6818 36.7046 33.6818V30.6818ZM19.4546 13.4091C18.6262 13.4091 17.9546 14.0806 17.9546 14.9091C17.9546 15.7375 18.6262 16.4091 19.4546 16.4091V13.4091ZM41.75 30.6818H36.7046V33.6818H41.75V30.6818ZM42.5 29.9288C42.5 30.3465 42.1624 30.6818 41.75 30.6818V33.6818C43.823 33.6818 45.5 31.9997 45.5 29.9288H42.5ZM42.5 17.162V29.9288H45.5V17.162H42.5ZM41.75 16.4091C42.1624 16.4091 42.5 16.7443 42.5 17.162H45.5C45.5 15.0912 43.823 13.4091 41.75 13.4091V16.4091ZM19.4546 16.4091H41.75V13.4091H19.4546V16.4091Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Text Field
                        </div>
                    </div>}
                    {((searchActive && "text area".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("text-area")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 36C5.5 36.8284 6.17157 37.5 7 37.5H27.0663H41C41.8284 37.5 42.5 36.8284 42.5 36V25.8629V12C42.5 11.1716 41.8284 10.5 41 10.5H7C6.17157 10.5 5.5 11.1716 5.5 12V36ZM7 40.5C4.51472 40.5 2.5 38.4853 2.5 36V12C2.5 9.51472 4.51472 7.5 7 7.5H41C43.4853 7.5 45.5 9.51472 45.5 12V25.8629V36C45.5 38.4853 43.4853 40.5 41 40.5H27.0663H7ZM11.2222 22.5C10.3937 22.5 9.72217 23.1716 9.72217 24C9.72217 24.8284 10.3937 25.5 11.2222 25.5H36.2222C37.0506 25.5 37.7222 24.8284 37.7222 24C37.7222 23.1716 37.0506 22.5 36.2222 22.5H11.2222ZM9.72217 16.7778C9.72217 15.9493 10.3937 15.2778 11.2222 15.2778H36.2222C37.0506 15.2778 37.7222 15.9493 37.7222 16.7778C37.7222 17.6062 37.0506 18.2778 36.2222 18.2778H11.2222C10.3937 18.2778 9.72217 17.6062 9.72217 16.7778ZM11.2222 29.7222C10.3937 29.7222 9.72217 30.3938 9.72217 31.2222C9.72217 32.0507 10.3937 32.7222 11.2222 32.7222H17.3333C18.1617 32.7222 18.8333 32.0507 18.8333 31.2222C18.8333 30.3938 18.1617 29.7222 17.3333 29.7222H11.2222Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Text Area
                        </div>
                    </div>}
                    {((searchActive && "email".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("email")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M33.9721 31.6111C33.1437 31.6111 32.4721 32.2827 32.4721 33.1111C32.4721 33.9395 33.1437 34.6111 33.9721 34.6111V31.6111ZM7.33325 10.5C6.50482 10.5 5.83325 11.1716 5.83325 12C5.83325 12.8284 6.50482 13.5 7.33325 13.5V10.5ZM41.2499 31.6111H33.9721V34.6111H41.2499V31.6111ZM42.4999 30.3575C42.4999 31.0517 41.9384 31.6111 41.2499 31.6111V34.6111C43.599 34.6111 45.4999 32.7048 45.4999 30.3575H42.4999ZM42.4999 14.7536V30.3575H45.4999V14.7536H42.4999ZM41.2499 13.5C41.9384 13.5 42.4999 14.0594 42.4999 14.7536H45.4999C45.4999 12.4063 43.599 10.5 41.2499 10.5V13.5ZM7.33325 13.5H41.2499V10.5H7.33325V13.5Z" fill="#414859"></path><rect x="4" y="19.7778" width="22.2222" height="16.6667" rx="2" stroke="#414859" stroke-width="3"></rect><path d="M5.66675 22.5556L15.0245 29.2222L25.1112 22" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Email
                        </div>
                    </div>}
                    {((searchActive && "password".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("password")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.1218 14.5835H42.4362C43.9626 14.5835 45.2001 15.8225 45.2001 17.3509V33.0333C45.2001 34.5617 43.9626 35.8008 42.4362 35.8008H36.2161" stroke="#414859" stroke-width="3" stroke-linecap="round"></path><path d="M21.5094 40H6.90293C4.96805 40 3.3999 38.4713 3.3999 36.585V27.2151C3.3999 25.3288 4.96805 23.8 6.90293 23.8H21.4968C23.4317 23.8 24.9998 25.3288 24.9998 27.2151V36.585C25.0125 38.4713 23.4443 40 21.5094 40Z" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M20.68 23.598V19.6535C20.68 15.9822 17.7755 13 14.2 13C10.6244 13 7.71997 15.9822 7.71997 19.6535V23.8" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Password
                        </div>
                    </div>}
                    {((searchActive && "phone".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("phone")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M37.076 30.7886C36.2475 30.7886 35.576 31.4601 35.576 32.2886C35.576 33.117 36.2475 33.7886 37.076 33.7886V30.7886ZM18.3738 12.0617C17.5454 12.0617 16.8738 12.7333 16.8738 13.5617C16.8738 14.3902 17.5454 15.0617 18.3738 15.0617V12.0617ZM41.5605 30.7886H37.076V33.7886H41.5605V30.7886ZM42.5 29.8459C42.5 30.3684 42.0775 30.7886 41.5605 30.7886V33.7886C43.7381 33.7886 45.5 32.0215 45.5 29.8459H42.5ZM42.5 16.0044V29.8459H45.5V16.0044H42.5ZM41.5605 15.0617C42.0775 15.0617 42.5 15.4819 42.5 16.0044H45.5C45.5 13.8288 43.7381 12.0617 41.5605 12.0617V15.0617ZM18.3738 15.0617H41.5605V12.0617H18.3738V15.0617Z" fill="#414859"></path><path d="M14.1878 17.0509L10.1587 12.4002C9.69426 11.8642 8.84272 11.8666 8.30322 12.4073L4.98996 15.7265C4.00385 16.7138 3.72159 18.1799 4.29206 19.3554C7.70014 26.4118 13.3911 32.1107 20.4427 35.5286C21.617 36.0991 23.0818 35.8168 24.068 34.8295L27.4122 31.4794C27.9541 30.9375 27.9553 30.0812 27.4146 29.6167L22.746 25.6091C22.2577 25.1899 21.4991 25.2447 21.0096 25.7354L19.3851 27.3622C19.3019 27.4494 19.1925 27.5068 19.0735 27.5258C18.9545 27.5447 18.8326 27.524 18.7265 27.467C16.0712 25.9379 13.8686 23.7324 12.343 21.0751C12.2858 20.9688 12.2651 20.8467 12.2841 20.7276C12.303 20.6084 12.3605 20.4987 12.4478 20.4153L14.0675 18.7944C14.5581 18.3014 14.6117 17.5392 14.1878 17.0497V17.0509Z" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Phone
                        </div>
                    </div>}
                    {((searchActive && "number".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("number")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M37.9223 32.7163C37.0939 32.7163 36.4223 33.3879 36.4223 34.2163C36.4223 35.0447 37.0939 35.7163 37.9223 35.7163V32.7163ZM2.21753 11.5C1.3891 11.5 0.717529 12.1716 0.717529 13C0.717529 13.8284 1.3891 14.5 2.21753 14.5V11.5ZM45.2363 32.7163H37.9223V35.7163H45.2363V32.7163ZM46.5 31.4489C46.5 32.1507 45.9324 32.7163 45.2363 32.7163V35.7163C47.593 35.7163 49.5 33.8039 49.5 31.4489H46.5ZM46.5 15.7673V31.4489H49.5V15.7673H46.5ZM45.2363 14.5C45.9324 14.5 46.5 15.0655 46.5 15.7673H49.5C49.5 13.4124 47.593 11.5 45.2363 11.5V14.5ZM2.21753 14.5H45.2363V11.5H2.21753V14.5Z" fill="#414859"></path><path d="M6.00508 35.3329V19.7852H3.16631L0 22.5367V25.5938L3.16631 22.8424V35.3329H6.00508Z" fill="#414859"></path><path d="M20.5694 35.3329V32.778H14.5644L18.9099 27.7338C19.9799 26.4891 20.5694 25.6811 20.5694 24.1744C20.5694 21.3793 18.6041 19.6542 15.8527 19.6542C13.1887 19.6542 11.1142 21.3575 11.1142 24.1962H13.9529C13.9529 22.6895 14.9137 22.2091 15.8527 22.2091C17.0537 22.2091 17.7307 22.9952 17.7307 24.1526C17.7307 24.8732 17.4905 25.3536 16.9227 26.0305L11.1142 32.778V35.3329H20.5694Z" fill="#414859"></path><path d="M32.7099 30.8346C32.7099 28.9566 31.8146 27.8866 30.701 27.297C31.7273 26.7511 32.4916 25.7903 32.4916 24.1089C32.4916 21.4885 30.5044 19.6542 27.753 19.6542C25.1326 19.6542 23.0581 21.3138 22.9926 24.0871H25.8314C25.8969 22.9079 26.683 22.2091 27.753 22.2091C28.7793 22.2091 29.6528 22.886 29.6528 24.1962C29.6528 25.2881 29.0632 26.1397 27.6875 26.1397H27.2726V28.6072H27.6875C29.085 28.6072 29.8712 29.4589 29.8712 30.7472C29.8712 32.1448 28.9977 32.9091 27.7749 32.9091C26.6612 32.9091 25.7004 32.2758 25.6567 30.8783H22.8179C22.8616 34.1319 25.2418 35.464 27.7749 35.464C30.4389 35.464 32.7099 33.9354 32.7099 30.8346Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Number
                        </div>
                    </div>}
                    {((searchActive && "checkbox".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("check-box")}
                    style={{
                        borderBottom: "0.5px solid #cccccc57",
                        width: "80%"
                    }}>
                    <div className="ElementIcon">
                        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.6579C22.6452 8.6579 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.6579ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.6579 43.9999 8.6579V11.6579ZM23.4736 11.6579H43.9999V8.6579H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.0389 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.0389 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M8.21045 13.5072L10.1754 15.4211L16.6315 9.10526" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <div className="ElementText">
                        Checkbox
                    </div>
                    {/* <img src="/assets/icons/ai.svg" style={{ width: "1rem", marginLeft: "5px" }} /> */}
                </div>}
                    {((searchActive && "checkbox group Multi choice multi select".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("check-group")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.6579C22.6452 8.6579 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.6579ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.6579 43.9999 8.6579V11.6579ZM23.4736 11.6579H43.9999V8.6579H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.0389 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.0389 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M8.21045 13.5072L10.1754 15.4211L16.6315 9.10526" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            {/* Checkbox Group */}
                            Multi choice multi select
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem", marginLeft: "5px" }} />
                    </div>}

                    {((searchActive && "checkbox image Multi choice multi select".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("check-image")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.6579C22.6452 8.6579 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.6579ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.6579 43.9999 8.6579V11.6579ZM23.4736 11.6579H43.9999V8.6579H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.0389 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.0389 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><path d="M8.21045 13.5072L10.1754 15.4211L16.6315 9.10526" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            {/* Checkbox Image */}
                            Multi choice multi select Image
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem", marginLeft: "5px" }} />
                    </div>}

                    {((searchActive && "radio group Multi choice single select".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("radio-group")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            {/* Radio Group */}
                            Multi choice single select
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem", marginLeft: "5px" }} />
                    </div>}

                    {((searchActive && "radio image Multi choice single select".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("radio-image")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            {/* Radio Image */}
                            Multi choice single select Image
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem", marginLeft: "5px" }} />
                    </div>}

                    {((searchActive && "radio multi image Multi choice single select".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("radio-multi-image")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            {/* Radio Multi Image */}
                            Multi choice single select with Multi Image
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem" }} />
                    </div>}
                    {((searchActive && "matrix".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("matrix")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            {/* <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                        </svg> */}
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 11.2104 15.421)" fill="#414859"></rect><rect x="7" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="12.6316" height="12.6316" rx="6.31579" transform="matrix(1 0 0 -1 27.6316 19.6316)" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="7" y="27.6316" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect x="31.842" y="31.8422" width="4.21053" height="4.21053" rx="2.10526" fill="#414859"></rect><rect width="12.6316" height="12.6316" rx="6.31579" transform="matrix(1 0 0 -1 27.6316 40.2632)" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect></svg>
                        </div>
                        <div className="ElementText">
                            Matrix
                        </div>
                    </div>}


                    {((searchActive && "rating".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("rating")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4768 29.3168C10.4768 27.6599 11.82 26.3168 13.4768 26.3168H18.3343C18.4103 26.3168 18.4856 26.3196 18.5602 26.3252C19.1208 25.9737 19.6017 25.5081 19.9712 24.958C20.3673 24.3684 20.6253 23.6969 20.7258 22.9938C20.7258 22.9937 20.7258 22.9938 20.7258 22.9938L20.8014 22.4644C21.0829 20.4938 22.7706 19.03 24.7612 19.03H24.8145C26.0382 19.0315 27.2114 19.5182 28.0767 20.3835C28.9419 21.2488 29.4287 22.422 29.4301 23.6456L29.4301 23.6492V26.3163H33.7164C34.7268 26.3163 35.6957 26.7176 36.4102 27.4321C37.1246 28.1465 37.526 29.1155 37.526 30.1259C37.526 31.0254 37.2078 31.8922 36.6338 32.5757C36.6883 32.8332 36.7164 33.0975 36.7164 33.3647C36.7164 33.9298 36.5908 34.482 36.3552 34.9839C36.5908 35.4858 36.7164 36.0379 36.7164 36.603C36.7164 37.1681 36.5908 37.7203 36.3552 38.2222C36.5908 38.7241 36.7164 39.2763 36.7164 39.8414C36.7164 40.8518 36.315 41.8207 35.6006 42.5352C34.8862 43.2496 33.9172 43.651 32.9068 43.651L23.6124 43.651C23.6116 43.651 23.6108 43.651 23.61 43.651C23.6099 43.651 23.6102 43.651 23.61 43.651C21.8492 43.6521 20.1273 43.1308 18.6628 42.1533C18.6626 42.1531 18.663 42.1534 18.6628 42.1533C18.6623 42.1529 18.6611 42.1521 18.6605 42.1517L18.4757 42.0285C18.4288 42.0307 18.3817 42.0318 18.3343 42.0318H13.4768C11.82 42.0318 10.4768 40.6887 10.4768 39.0318V29.3168ZM18.3343 39.0318V29.3168H13.4768V39.0318H18.3343ZM21.1349 40.1095C21.9076 40.4655 22.7516 40.6518 23.6096 40.651H32.9068C33.1215 40.651 33.3275 40.5657 33.4793 40.4138C33.496 40.3971 33.5119 40.3798 33.5269 40.3618C33.5408 40.3454 33.5539 40.3284 33.5663 40.311C33.6633 40.1748 33.7164 40.0108 33.7164 39.8414C33.7164 39.6267 33.6311 39.4207 33.4793 39.2689C33.3275 39.1171 33.1215 39.0318 32.9068 39.0318C32.6921 39.0318 32.4862 38.9465 32.3344 38.7947C32.3177 38.778 32.3018 38.7606 32.2867 38.7427C32.2729 38.7262 32.2598 38.7093 32.2474 38.6918C32.1504 38.5556 32.0972 38.3917 32.0972 38.2222C32.0972 38.0528 32.1504 37.8888 32.2474 37.7526C32.273 37.7166 32.3016 37.6826 32.3331 37.651C32.3335 37.6506 32.334 37.6502 32.3344 37.6497C32.4862 37.4979 32.6921 37.4126 32.9068 37.4126C33.1215 37.4126 33.3275 37.3273 33.4793 37.1755C33.496 37.1588 33.5119 37.1415 33.5269 37.1235C33.5408 37.107 33.5539 37.0901 33.5663 37.0727C33.6633 36.9364 33.7164 36.7725 33.7164 36.603C33.7164 36.4336 33.6633 36.2696 33.5663 36.1334C33.5539 36.116 33.5408 36.0991 33.5269 36.0826C33.5119 36.0646 33.496 36.0473 33.4793 36.0306C33.3275 35.8788 33.1215 35.7935 32.9068 35.7935C32.6921 35.7935 32.4862 35.7082 32.3344 35.5563C32.3177 35.5396 32.3018 35.5223 32.2867 35.5043C32.2729 35.4879 32.2598 35.4709 32.2474 35.4535C32.1504 35.3173 32.0972 35.1533 32.0972 34.9839C32.0972 34.8144 32.1504 34.6505 32.2474 34.5143C32.2598 34.4968 32.2729 34.4799 32.2867 34.4634C32.3018 34.4455 32.3177 34.4281 32.3344 34.4114C32.4862 34.2596 32.6921 34.1743 32.9068 34.1743C33.1215 34.1743 33.3275 34.089 33.4793 33.9372C33.4797 33.9368 33.4801 33.9364 33.4805 33.936C33.512 33.9043 33.5407 33.8703 33.5663 33.8343C33.6633 33.6981 33.7164 33.5341 33.7164 33.3647C33.7164 33.1953 33.6633 33.0313 33.5663 32.8951C33.5539 32.8777 33.5408 32.8607 33.5269 32.8443C33.5119 32.8263 33.496 32.8089 33.4793 32.7922C33.3275 32.6404 33.1215 32.5551 32.9068 32.5551C32.6921 32.5551 32.4862 32.4698 32.3344 32.318C32.3338 32.3174 32.3332 32.3169 32.3326 32.3163C32.1819 32.1646 32.0972 31.9594 32.0972 31.7455C32.0972 31.7008 32.1009 31.6565 32.1082 31.613C32.1283 31.4915 32.1759 31.3762 32.2474 31.2759C32.2598 31.2585 32.2729 31.2415 32.2867 31.2251C32.3018 31.2071 32.3177 31.1898 32.3344 31.1731C32.4861 31.0214 32.6918 30.9361 32.9063 30.936C32.9065 30.936 32.9061 30.936 32.9063 30.936H33.7164C33.9311 30.936 34.137 30.8502 34.2889 30.6983C34.4091 30.5781 34.4876 30.424 34.5151 30.2584C34.5223 30.2149 34.526 30.1706 34.526 30.1259C34.526 30.0493 34.5151 29.9739 34.4943 29.9016C34.4567 29.7712 34.3866 29.6511 34.2889 29.5534C34.137 29.4016 33.9311 29.3163 33.7164 29.3163H27.2397C27.025 29.3163 26.8191 29.231 26.6673 29.0792C26.5154 28.9273 26.4301 28.7214 26.4301 28.5067V23.6492C26.43 23.5175 26.4138 23.3874 26.3827 23.2616C26.3123 22.9775 26.1657 22.7152 25.9553 22.5048C25.6518 22.2013 25.2403 22.0305 24.811 22.03H24.7612C24.2636 22.03 23.8417 22.396 23.7713 22.8886L23.6957 23.418C23.6846 23.4953 23.6724 23.5724 23.659 23.6492C23.6589 23.6503 23.6587 23.6514 23.6585 23.6525C23.6265 23.8357 23.588 24.0175 23.543 24.1974C23.509 24.3333 23.4714 24.4682 23.4301 24.6019C23.2086 25.3198 22.8828 26.0037 22.4614 26.631C22.0781 27.2016 21.6214 27.7167 21.1047 28.1638C20.7481 28.4724 20.3629 28.7486 19.9535 28.9883V39.4082L20.3269 39.6571C20.5851 39.8296 20.8553 39.9806 21.1349 40.1095Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.0675 6.5724L24.0688 6.57662ZM24.4885 7.86899L25.1097 9.78172H27.1185L25.4936 10.9619L26.1143 12.8729L24.4885 11.6917L22.863 12.8728L23.4836 10.9619L21.8587 9.78172H23.8674L24.4885 7.86899ZM23.6403 5.27684C23.8865 5.09694 24.1836 5 24.4885 5C24.7935 5 25.0906 5.09694 25.3368 5.27684C25.5822 5.45614 25.7645 5.70859 25.8575 5.99792L26.4758 7.90172H28.4794C28.7829 7.90187 29.0791 7.99806 29.3246 8.17651C29.5701 8.35497 29.7529 8.60653 29.8467 8.89518C29.9405 9.18384 29.9406 9.49478 29.8469 9.78348C29.7533 10.0722 29.5707 10.3239 29.3252 10.5024L27.7036 11.6803L28.3225 13.5859C28.4162 13.8747 28.4161 14.186 28.3222 14.4747C28.2283 14.7634 28.0454 15.015 27.7998 15.1934C27.5541 15.3718 27.2583 15.4679 26.9547 15.4679C26.6511 15.4679 26.3553 15.3718 26.1096 15.1933L24.4885 14.0155L22.8675 15.1933C22.6219 15.3716 22.3258 15.4678 22.0223 15.4678C21.7187 15.4678 21.423 15.3717 21.1774 15.1933C20.9318 15.0149 20.7489 14.7633 20.655 14.4747C20.5611 14.186 20.5609 13.8751 20.6546 13.5863L21.2736 11.6803L19.6526 10.5029C19.4072 10.3244 19.2239 10.0722 19.1303 9.78355C19.0366 9.49487 19.0367 9.18396 19.1304 8.89532C19.2242 8.60668 19.407 8.35512 19.6524 8.17664C19.8979 7.99817 20.1935 7.90194 20.497 7.90172L22.5013 7.90172L23.1196 5.99785C23.2126 5.70855 23.3949 5.45613 23.6403 5.27684Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.0675 11.5724L11.0688 11.5766ZM11.4885 12.869L12.1097 14.7817H14.1185L12.4936 15.9619L13.1143 17.8729L11.4885 16.6917L9.86295 17.8728L10.4836 15.9619L8.85874 14.7817H10.8674L11.4885 12.869ZM10.6403 10.2768C10.8865 10.0969 11.1836 10 11.4885 10C11.7935 10 12.0906 10.0969 12.3368 10.2768C12.5822 10.4561 12.7645 10.7086 12.8575 10.9979L13.4758 12.9017H15.4794C15.7829 12.9019 16.0791 12.9981 16.3246 13.1765C16.5701 13.355 16.7529 13.6065 16.8467 13.8952C16.9405 14.1838 16.9406 14.4948 16.8469 14.7835C16.7533 15.0722 16.5707 15.3239 16.3252 15.5024L14.7036 16.6803L15.3225 18.5859C15.4162 18.8747 15.4161 19.186 15.3222 19.4747C15.2283 19.7634 15.0454 20.015 14.7998 20.1934C14.5541 20.3718 14.2583 20.4679 13.9547 20.4679C13.6511 20.4679 13.3553 20.3718 13.1096 20.1933L11.4885 19.0155L9.86754 20.1933C9.62189 20.3716 9.3258 20.4678 9.02226 20.4678C8.71872 20.4678 8.42297 20.3717 8.17737 20.1933C7.93178 20.0149 7.74893 19.7633 7.65502 19.4747C7.56111 19.186 7.56095 18.8751 7.65456 18.5863L8.27358 16.6803L6.65263 15.5029C6.40723 15.3244 6.22394 15.0722 6.13027 14.7836C6.03659 14.4949 6.03666 14.184 6.13045 13.8953C6.22424 13.6067 6.40695 13.3551 6.65242 13.1766C6.8979 12.9982 7.19354 12.9019 7.49704 12.9017L9.50126 12.9017L10.1196 10.9978C10.2126 10.7086 10.3949 10.4561 10.6403 10.2768Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M36.0675 11.5724L36.0688 11.5766ZM36.4885 12.869L37.1097 14.7817H39.1185L37.4936 15.9619L38.1143 17.8729L36.4885 16.6917L34.863 17.8728L35.4836 15.9619L33.8587 14.7817H35.8674L36.4885 12.869ZM35.6403 10.2768C35.8865 10.0969 36.1836 10 36.4885 10C36.7935 10 37.0906 10.0969 37.3368 10.2768C37.5822 10.4561 37.7645 10.7086 37.8575 10.9979L38.4758 12.9017H40.4794C40.7829 12.9019 41.0791 12.9981 41.3246 13.1765C41.5701 13.355 41.7529 13.6065 41.8467 13.8952C41.9405 14.1838 41.9406 14.4948 41.8469 14.7835C41.7533 15.0722 41.5707 15.3239 41.3252 15.5024L39.7036 16.6803L40.3225 18.5859C40.4162 18.8747 40.4161 19.186 40.3222 19.4747C40.2283 19.7634 40.0454 20.015 39.7998 20.1934C39.5541 20.3718 39.2583 20.4679 38.9547 20.4679C38.6511 20.4679 38.3553 20.3718 38.1096 20.1933L36.4885 19.0155L34.8675 20.1933C34.6219 20.3716 34.3258 20.4678 34.0223 20.4678C33.7187 20.4678 33.423 20.3717 33.1774 20.1933C32.9318 20.0149 32.7489 19.7633 32.655 19.4747C32.5611 19.186 32.5609 18.8751 32.6546 18.5863L33.2736 16.6803L31.6526 15.5029C31.4072 15.3244 31.2239 15.0722 31.1303 14.7836C31.0366 14.4949 31.0367 14.184 31.1304 13.8953C31.2242 13.6067 31.407 13.3551 31.6524 13.1766C31.8979 12.9982 32.1935 12.9019 32.497 12.9017L34.5013 12.9017L35.1196 10.9978C35.2126 10.7086 35.3949 10.4561 35.6403 10.2768Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Rating
                        </div>
                    </div>}

                    {((searchActive && "nps".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("nps")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4768 29.3168C10.4768 27.6599 11.82 26.3168 13.4768 26.3168H18.3343C18.4103 26.3168 18.4856 26.3196 18.5602 26.3252C19.1208 25.9737 19.6017 25.5081 19.9712 24.958C20.3673 24.3684 20.6253 23.6969 20.7258 22.9938C20.7258 22.9937 20.7258 22.9938 20.7258 22.9938L20.8014 22.4644C21.0829 20.4938 22.7706 19.03 24.7612 19.03H24.8145C26.0382 19.0315 27.2114 19.5182 28.0767 20.3835C28.9419 21.2488 29.4287 22.422 29.4301 23.6456L29.4301 23.6492V26.3163H33.7164C34.7268 26.3163 35.6957 26.7176 36.4102 27.4321C37.1246 28.1465 37.526 29.1155 37.526 30.1259C37.526 31.0254 37.2078 31.8922 36.6338 32.5757C36.6883 32.8332 36.7164 33.0975 36.7164 33.3647C36.7164 33.9298 36.5908 34.482 36.3552 34.9839C36.5908 35.4858 36.7164 36.0379 36.7164 36.603C36.7164 37.1681 36.5908 37.7203 36.3552 38.2222C36.5908 38.7241 36.7164 39.2763 36.7164 39.8414C36.7164 40.8518 36.315 41.8207 35.6006 42.5352C34.8862 43.2496 33.9172 43.651 32.9068 43.651L23.6124 43.651C23.6116 43.651 23.6108 43.651 23.61 43.651C23.6099 43.651 23.6102 43.651 23.61 43.651C21.8492 43.6521 20.1273 43.1308 18.6628 42.1533C18.6626 42.1531 18.663 42.1534 18.6628 42.1533C18.6623 42.1529 18.6611 42.1521 18.6605 42.1517L18.4757 42.0285C18.4288 42.0307 18.3817 42.0318 18.3343 42.0318H13.4768C11.82 42.0318 10.4768 40.6887 10.4768 39.0318V29.3168ZM18.3343 39.0318V29.3168H13.4768V39.0318H18.3343ZM21.1349 40.1095C21.9076 40.4655 22.7516 40.6518 23.6096 40.651H32.9068C33.1215 40.651 33.3275 40.5657 33.4793 40.4138C33.496 40.3971 33.5119 40.3798 33.5269 40.3618C33.5408 40.3454 33.5539 40.3284 33.5663 40.311C33.6633 40.1748 33.7164 40.0108 33.7164 39.8414C33.7164 39.6267 33.6311 39.4207 33.4793 39.2689C33.3275 39.1171 33.1215 39.0318 32.9068 39.0318C32.6921 39.0318 32.4862 38.9465 32.3344 38.7947C32.3177 38.778 32.3018 38.7606 32.2867 38.7427C32.2729 38.7262 32.2598 38.7093 32.2474 38.6918C32.1504 38.5556 32.0972 38.3917 32.0972 38.2222C32.0972 38.0528 32.1504 37.8888 32.2474 37.7526C32.273 37.7166 32.3016 37.6826 32.3331 37.651C32.3335 37.6506 32.334 37.6502 32.3344 37.6497C32.4862 37.4979 32.6921 37.4126 32.9068 37.4126C33.1215 37.4126 33.3275 37.3273 33.4793 37.1755C33.496 37.1588 33.5119 37.1415 33.5269 37.1235C33.5408 37.107 33.5539 37.0901 33.5663 37.0727C33.6633 36.9364 33.7164 36.7725 33.7164 36.603C33.7164 36.4336 33.6633 36.2696 33.5663 36.1334C33.5539 36.116 33.5408 36.0991 33.5269 36.0826C33.5119 36.0646 33.496 36.0473 33.4793 36.0306C33.3275 35.8788 33.1215 35.7935 32.9068 35.7935C32.6921 35.7935 32.4862 35.7082 32.3344 35.5563C32.3177 35.5396 32.3018 35.5223 32.2867 35.5043C32.2729 35.4879 32.2598 35.4709 32.2474 35.4535C32.1504 35.3173 32.0972 35.1533 32.0972 34.9839C32.0972 34.8144 32.1504 34.6505 32.2474 34.5143C32.2598 34.4968 32.2729 34.4799 32.2867 34.4634C32.3018 34.4455 32.3177 34.4281 32.3344 34.4114C32.4862 34.2596 32.6921 34.1743 32.9068 34.1743C33.1215 34.1743 33.3275 34.089 33.4793 33.9372C33.4797 33.9368 33.4801 33.9364 33.4805 33.936C33.512 33.9043 33.5407 33.8703 33.5663 33.8343C33.6633 33.6981 33.7164 33.5341 33.7164 33.3647C33.7164 33.1953 33.6633 33.0313 33.5663 32.8951C33.5539 32.8777 33.5408 32.8607 33.5269 32.8443C33.5119 32.8263 33.496 32.8089 33.4793 32.7922C33.3275 32.6404 33.1215 32.5551 32.9068 32.5551C32.6921 32.5551 32.4862 32.4698 32.3344 32.318C32.3338 32.3174 32.3332 32.3169 32.3326 32.3163C32.1819 32.1646 32.0972 31.9594 32.0972 31.7455C32.0972 31.7008 32.1009 31.6565 32.1082 31.613C32.1283 31.4915 32.1759 31.3762 32.2474 31.2759C32.2598 31.2585 32.2729 31.2415 32.2867 31.2251C32.3018 31.2071 32.3177 31.1898 32.3344 31.1731C32.4861 31.0214 32.6918 30.9361 32.9063 30.936C32.9065 30.936 32.9061 30.936 32.9063 30.936H33.7164C33.9311 30.936 34.137 30.8502 34.2889 30.6983C34.4091 30.5781 34.4876 30.424 34.5151 30.2584C34.5223 30.2149 34.526 30.1706 34.526 30.1259C34.526 30.0493 34.5151 29.9739 34.4943 29.9016C34.4567 29.7712 34.3866 29.6511 34.2889 29.5534C34.137 29.4016 33.9311 29.3163 33.7164 29.3163H27.2397C27.025 29.3163 26.8191 29.231 26.6673 29.0792C26.5154 28.9273 26.4301 28.7214 26.4301 28.5067V23.6492C26.43 23.5175 26.4138 23.3874 26.3827 23.2616C26.3123 22.9775 26.1657 22.7152 25.9553 22.5048C25.6518 22.2013 25.2403 22.0305 24.811 22.03H24.7612C24.2636 22.03 23.8417 22.396 23.7713 22.8886L23.6957 23.418C23.6846 23.4953 23.6724 23.5724 23.659 23.6492C23.6589 23.6503 23.6587 23.6514 23.6585 23.6525C23.6265 23.8357 23.588 24.0175 23.543 24.1974C23.509 24.3333 23.4714 24.4682 23.4301 24.6019C23.2086 25.3198 22.8828 26.0037 22.4614 26.631C22.0781 27.2016 21.6214 27.7167 21.1047 28.1638C20.7481 28.4724 20.3629 28.7486 19.9535 28.9883V39.4082L20.3269 39.6571C20.5851 39.8296 20.8553 39.9806 21.1349 40.1095Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M24.0675 6.5724L24.0688 6.57662ZM24.4885 7.86899L25.1097 9.78172H27.1185L25.4936 10.9619L26.1143 12.8729L24.4885 11.6917L22.863 12.8728L23.4836 10.9619L21.8587 9.78172H23.8674L24.4885 7.86899ZM23.6403 5.27684C23.8865 5.09694 24.1836 5 24.4885 5C24.7935 5 25.0906 5.09694 25.3368 5.27684C25.5822 5.45614 25.7645 5.70859 25.8575 5.99792L26.4758 7.90172H28.4794C28.7829 7.90187 29.0791 7.99806 29.3246 8.17651C29.5701 8.35497 29.7529 8.60653 29.8467 8.89518C29.9405 9.18384 29.9406 9.49478 29.8469 9.78348C29.7533 10.0722 29.5707 10.3239 29.3252 10.5024L27.7036 11.6803L28.3225 13.5859C28.4162 13.8747 28.4161 14.186 28.3222 14.4747C28.2283 14.7634 28.0454 15.015 27.7998 15.1934C27.5541 15.3718 27.2583 15.4679 26.9547 15.4679C26.6511 15.4679 26.3553 15.3718 26.1096 15.1933L24.4885 14.0155L22.8675 15.1933C22.6219 15.3716 22.3258 15.4678 22.0223 15.4678C21.7187 15.4678 21.423 15.3717 21.1774 15.1933C20.9318 15.0149 20.7489 14.7633 20.655 14.4747C20.5611 14.186 20.5609 13.8751 20.6546 13.5863L21.2736 11.6803L19.6526 10.5029C19.4072 10.3244 19.2239 10.0722 19.1303 9.78355C19.0366 9.49487 19.0367 9.18396 19.1304 8.89532C19.2242 8.60668 19.407 8.35512 19.6524 8.17664C19.8979 7.99817 20.1935 7.90194 20.497 7.90172L22.5013 7.90172L23.1196 5.99785C23.2126 5.70855 23.3949 5.45613 23.6403 5.27684Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.0675 11.5724L11.0688 11.5766ZM11.4885 12.869L12.1097 14.7817H14.1185L12.4936 15.9619L13.1143 17.8729L11.4885 16.6917L9.86295 17.8728L10.4836 15.9619L8.85874 14.7817H10.8674L11.4885 12.869ZM10.6403 10.2768C10.8865 10.0969 11.1836 10 11.4885 10C11.7935 10 12.0906 10.0969 12.3368 10.2768C12.5822 10.4561 12.7645 10.7086 12.8575 10.9979L13.4758 12.9017H15.4794C15.7829 12.9019 16.0791 12.9981 16.3246 13.1765C16.5701 13.355 16.7529 13.6065 16.8467 13.8952C16.9405 14.1838 16.9406 14.4948 16.8469 14.7835C16.7533 15.0722 16.5707 15.3239 16.3252 15.5024L14.7036 16.6803L15.3225 18.5859C15.4162 18.8747 15.4161 19.186 15.3222 19.4747C15.2283 19.7634 15.0454 20.015 14.7998 20.1934C14.5541 20.3718 14.2583 20.4679 13.9547 20.4679C13.6511 20.4679 13.3553 20.3718 13.1096 20.1933L11.4885 19.0155L9.86754 20.1933C9.62189 20.3716 9.3258 20.4678 9.02226 20.4678C8.71872 20.4678 8.42297 20.3717 8.17737 20.1933C7.93178 20.0149 7.74893 19.7633 7.65502 19.4747C7.56111 19.186 7.56095 18.8751 7.65456 18.5863L8.27358 16.6803L6.65263 15.5029C6.40723 15.3244 6.22394 15.0722 6.13027 14.7836C6.03659 14.4949 6.03666 14.184 6.13045 13.8953C6.22424 13.6067 6.40695 13.3551 6.65242 13.1766C6.8979 12.9982 7.19354 12.9019 7.49704 12.9017L9.50126 12.9017L10.1196 10.9978C10.2126 10.7086 10.3949 10.4561 10.6403 10.2768Z" fill="#414859"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M36.0675 11.5724L36.0688 11.5766ZM36.4885 12.869L37.1097 14.7817H39.1185L37.4936 15.9619L38.1143 17.8729L36.4885 16.6917L34.863 17.8728L35.4836 15.9619L33.8587 14.7817H35.8674L36.4885 12.869ZM35.6403 10.2768C35.8865 10.0969 36.1836 10 36.4885 10C36.7935 10 37.0906 10.0969 37.3368 10.2768C37.5822 10.4561 37.7645 10.7086 37.8575 10.9979L38.4758 12.9017H40.4794C40.7829 12.9019 41.0791 12.9981 41.3246 13.1765C41.5701 13.355 41.7529 13.6065 41.8467 13.8952C41.9405 14.1838 41.9406 14.4948 41.8469 14.7835C41.7533 15.0722 41.5707 15.3239 41.3252 15.5024L39.7036 16.6803L40.3225 18.5859C40.4162 18.8747 40.4161 19.186 40.3222 19.4747C40.2283 19.7634 40.0454 20.015 39.7998 20.1934C39.5541 20.3718 39.2583 20.4679 38.9547 20.4679C38.6511 20.4679 38.3553 20.3718 38.1096 20.1933L36.4885 19.0155L34.8675 20.1933C34.6219 20.3716 34.3258 20.4678 34.0223 20.4678C33.7187 20.4678 33.423 20.3717 33.1774 20.1933C32.9318 20.0149 32.7489 19.7633 32.655 19.4747C32.5611 19.186 32.5609 18.8751 32.6546 18.5863L33.2736 16.6803L31.6526 15.5029C31.4072 15.3244 31.2239 15.0722 31.1303 14.7836C31.0366 14.4949 31.0367 14.184 31.1304 13.8953C31.2242 13.6067 31.407 13.3551 31.6524 13.1766C31.8979 12.9982 32.1935 12.9019 32.497 12.9017L34.5013 12.9017L35.1196 10.9978C35.2126 10.7086 35.3949 10.4561 35.6403 10.2768Z" fill="#414859"></path>
                            </svg>
                        </div>
                        {/* <div className="ElementText">
                            NPS
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem" }} /> */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '37px'
                        }}>
                            <div className="ElementText">
                                NPS
                            </div>
                            <img src="/assets/icons/ai.svg" style={{ width: "1rem" }} />
                        </div>
                    </div>}

                    {((searchActive && "mcq".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("mcq")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Mcq
                        </div>
                    </div>}

                    {((searchActive && "mcq image".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("mcq-image")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Mcq Image
                        </div>
                    </div>}

                    {((searchActive && "dropdown".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("dropdown")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4" y="15" width="40" height="18.7755" rx="3" stroke="#414859" stroke-width="3" stroke-linecap="round"></rect><path d="M33.3877 23.1633L36.2448 26.0204L39.102 23.1633" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Dropdown
                        </div>
                    </div>}

                    {/* {((searchActive && "dropdown".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => addDropdownMultiselectElementHandler()}>
                    <div className="ElementIcon">
                        <svg viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 15H42C43.6569 15 45 16.3431 45 18V30.7755C45 32.4324 43.6682 33.7755 42.0114 33.7755C32.3769 33.7755 10.1975 33.7755 5.5 33.7755" stroke="#414859" stroke-width="3" stroke-linecap="round"></path><path d="M34.3877 23.1632L37.2448 26.0204L40.102 23.1632" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path><rect y="19" width="11" height="11" rx="2" fill="#BDC2CE"></rect><rect x="13" y="19" width="15" height="11" rx="2" fill="#BDC2CE"></rect>
                        </svg>
                    </div>
                    <div className="ElementText">
                        Dropdown Multiselect
                    </div>
                </div>} */}

                    {((searchActive && "date".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("date")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="6" y="8.44446" width="35.5556" height="35.5556" rx="3" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><line x1="7.5" y1="17.6111" x2="40.0556" y2="17.6111" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></line><line x1="14.6111" y1="5.5" x2="14.6111" y2="11.3889" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></line><line x1="34.1667" y1="5.5" x2="34.1667" y2="11.3889" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></line>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Date
                        </div>
                    </div>}

                    {((searchActive && "file".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("file-upload")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.1014 30.0785L24.0001 24.1904L29.8987 30.0785" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M24.0002 40.3009L24.0002 24.1905" stroke="#414859" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M34.9884 36.3363C39.9884 36.3363 44 32.2798 44 27.224C44 22.1681 39.9884 18.1117 34.9884 18.1117C34.9884 12.5267 30.5116 8 24.9884 8C20.7442 8 17.1395 10.6455 15.686 14.408C15.4535 14.408 15.2209 14.3492 14.9884 14.3492C8.94186 14.3492 4 19.2875 4 25.4603C4 31.5744 8.88372 36.5714 14.9884 36.5714" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            File Upload
                        </div>
                    </div>}

                    {((searchActive && "reorder".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("reorder")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Reorder
                        </div>
                    </div>}

                    {((searchActive && "reorder image".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("reorder-image")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Reorder Image
                        </div>
                    </div>}

                    {((searchActive && "flip card".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("flip-card")}
                        style={{
                            borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 36C5.5 36.8284 6.17157 37.5 7 37.5H27.0663H41C41.8284 37.5 42.5 36.8284 42.5 36V25.8629V12C42.5 11.1716 41.8284 10.5 41 10.5H7C6.17157 10.5 5.5 11.1716 5.5 12V36ZM7 40.5C4.51472 40.5 2.5 38.4853 2.5 36V12C2.5 9.51472 4.51472 7.5 7 7.5H41C43.4853 7.5 45.5 9.51472 45.5 12V25.8629V36C45.5 38.4853 43.4853 40.5 41 40.5H27.0663H7ZM11.2222 22.5C10.3937 22.5 9.72217 23.1716 9.72217 24C9.72217 24.8284 10.3937 25.5 11.2222 25.5H36.2222C37.0506 25.5 37.7222 24.8284 37.7222 24C37.7222 23.1716 37.0506 22.5 36.2222 22.5H11.2222ZM9.72217 16.7778C9.72217 15.9493 10.3937 15.2778 11.2222 15.2778H36.2222C37.0506 15.2778 37.7222 15.9493 37.7222 16.7778C37.7222 17.6062 37.0506 18.2778 36.2222 18.2778H11.2222C10.3937 18.2778 9.72217 17.6062 9.72217 16.7778ZM11.2222 29.7222C10.3937 29.7222 9.72217 30.3938 9.72217 31.2222C9.72217 32.0507 10.3937 32.7222 11.2222 32.7222H17.3333C18.1617 32.7222 18.8333 32.0507 18.8333 31.2222C18.8333 30.3938 18.1617 29.7222 17.3333 29.7222H11.2222Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Flip Card
                        </div>
                    </div>}

                    {((searchActive && "question answer".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("question-answer")}
                        style={{
                            // borderBottom: "0.5px solid #cccccc57",
                            width: "80%"
                        }}>
                        <div className="ElementIcon">
                            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 36C5.5 36.8284 6.17157 37.5 7 37.5H27.0663H41C41.8284 37.5 42.5 36.8284 42.5 36V25.8629V12C42.5 11.1716 41.8284 10.5 41 10.5H7C6.17157 10.5 5.5 11.1716 5.5 12V36ZM7 40.5C4.51472 40.5 2.5 38.4853 2.5 36V12C2.5 9.51472 4.51472 7.5 7 7.5H41C43.4853 7.5 45.5 9.51472 45.5 12V25.8629V36C45.5 38.4853 43.4853 40.5 41 40.5H27.0663H7ZM11.2222 22.5C10.3937 22.5 9.72217 23.1716 9.72217 24C9.72217 24.8284 10.3937 25.5 11.2222 25.5H36.2222C37.0506 25.5 37.7222 24.8284 37.7222 24C37.7222 23.1716 37.0506 22.5 36.2222 22.5H11.2222ZM9.72217 16.7778C9.72217 15.9493 10.3937 15.2778 11.2222 15.2778H36.2222C37.0506 15.2778 37.7222 15.9493 37.7222 16.7778C37.7222 17.6062 37.0506 18.2778 36.2222 18.2778H11.2222C10.3937 18.2778 9.72217 17.6062 9.72217 16.7778ZM11.2222 29.7222C10.3937 29.7222 9.72217 30.3938 9.72217 31.2222C9.72217 32.0507 10.3937 32.7222 11.2222 32.7222H17.3333C18.1617 32.7222 18.8333 32.0507 18.8333 31.2222C18.8333 30.3938 18.1617 29.7222 17.3333 29.7222H11.2222Z" fill="#414859"></path>
                            </svg>
                        </div>
                        <div className="ElementText">
                            Question Answer
                        </div>
                        <img src="/assets/icons/ai.svg" style={{ width: "1rem" }} />
                    </div>}
                    <div className="ElementDividerLine"></div>

                    <div className="ElementTextHeading" onClick={() => setresearcherTab(!researcherTab)}>Researcher
                        <svg style={{ transform: researcherTab ? "rotate(180deg)" : "none", padding: "2px 4px" }} width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.26342 2.97603L2.24581 0.958417C1.6984 0.410996 0.81085 0.410997 0.263428 0.958418L4.26342 4.95841L8.26343 0.958418C7.71597 0.410997 6.82845 0.410997 6.28103 0.958418L4.26342 2.97603Z" fill="currentColor"></path>
                        </svg>
                    </div>
                    {researcherTab && <>
                        {((searchActive && "researcher generic conjoint".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("generic-conjoint")}
                            style={{
                                borderBottom: "0.5px solid #cccccc57",
                                width: "80%"
                            }}>
                            <div className="ElementIcon">
                                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                                </svg>
                            </div>
                            <div className="ElementText">
                                Generic Conjoint
                            </div>
                        </div>}
                        {((searchActive && "researcher best worst conjoint".includes(searchText)) || !searchActive) && <div className="ElementTextContainer" onClick={() => setShowElement("best-worst-conjoint")}
                            style={{
                                borderBottom: "0.5px solid #cccccc57",
                                width: "80%"
                            }}>
                            <div className="ElementIcon">
                                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23.4736 15.5C22.6452 15.5 21.9736 16.1716 21.9736 17C21.9736 17.8284 22.6452 18.5 23.4736 18.5V15.5ZM32.421 18.5C33.2494 18.5 33.921 17.8284 33.921 17C33.921 16.1716 33.2494 15.5 32.421 15.5V18.5ZM23.4736 18.5H32.421V15.5H23.4736V18.5Z" fill="#414859"></path><path d="M23.4736 36.5526C22.6452 36.5526 21.9736 37.2242 21.9736 38.0526C21.9736 38.8811 22.6452 39.5526 23.4736 39.5526V36.5526ZM32.421 39.5526C33.2494 39.5526 33.921 38.8811 33.921 38.0526C33.921 37.2242 33.2494 36.5526 32.421 36.5526V39.5526ZM23.4736 39.5526H32.421V36.5526H23.4736V39.5526Z" fill="#414859"></path><path d="M23.4736 8.65789C22.6452 8.65789 21.9736 9.32947 21.9736 10.1579C21.9736 10.9863 22.6452 11.6579 23.4736 11.6579V8.65789ZM43.9999 11.6579C44.8284 11.6579 45.4999 10.9863 45.4999 10.1579C45.4999 9.32947 44.8284 8.65789 43.9999 8.65789V11.6579ZM23.4736 11.6579H43.9999V8.65789H23.4736V11.6579Z" fill="#414859"></path><path d="M23.4736 29.7105C22.6452 29.7105 21.9736 30.3821 21.9736 31.2105C21.9736 32.039 22.6452 32.7105 23.4736 32.7105V29.7105ZM43.9999 32.7105C44.8284 32.7105 45.4999 32.039 45.4999 31.2105C45.4999 30.3821 44.8284 29.7105 43.9999 29.7105V32.7105ZM23.4736 32.7105H43.9999V29.7105H23.4736V32.7105Z" fill="#414859"></path><rect x="4" y="7" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect><rect width="4.21053" height="4.21053" rx="2.10526" transform="matrix(1 0 0 -1 8.21045 15.4211)" fill="#414859"></rect><rect x="4" y="28.0526" width="12.6316" height="12.6316" rx="6.31579" stroke="#414859" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></rect>
                                </svg>
                            </div>
                            <div className="ElementText">
                                Best-Worst Conjoint
                            </div>
                        </div>}
                    </>}
                </>}

            </div>
        </div>


    );
}

export default ElementModal;